// extracted by mini-css-extract-plugin
export default {"button":"indicador_button__J7mli","filtro":"indicador_filtro__+w0ml"};